import { useLayoutEffect, useMemo, useRef } from "react";
import { debounce2 } from "@exonn/utils";

export function useDebouncedCallback<R, A extends any[]>(
  callback: (...args: A) => R,
  wait: number,
  onFire?: (...args: NoInfer<A>) => void,
) {
  const callbackRef = useRef<(...args: A) => R>(callback);
  // Why useLayoutEffect? -> https://kcd.im/uselayouteffect

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return useMemo(
    () => debounce2((...args: A) => callbackRef.current(...args), wait, onFire),
    [wait, onFire],
  );
}
